import React from "react";
import { useHistory } from "react-router-dom";
import BetaIcon from "../../assets/beta.png";

const DashboardCards = ({ icon, title, link, pdr, subText, isBeta }) => {
  const history = useHistory();

  return (
    <div
      className="card"
      onClick={() => history.push(link)}
      style={{ cursor: "pointer" }}
    >
      <div className="icon-section">
        <img src={icon} alt="Menu List" />
      </div>
      <div className="cont">
        <div className="card-content">
          <p className={`${pdr} cardHeading`}>{title}</p>
          <p className="card-sub-content">{subText}</p>
        </div>

        {/* <div
          className="beta"
          style={{
            opacity: isBeta ? 1 : 0,
            visibility: isBeta ? "visible" : "hidden",
            transition: "opacity 0.3s ease",
          }}
        >
          <img src={BetaIcon} alt="beta-icon" className="beta-icon" />
          <p className="beta-text">Beta</p>
        </div> */}

        {isBeta && (
          <div className="beta">
            <img src={BetaIcon} alt="beta-icon" className="beta-icon" />
            <p className="beta-text">Beta</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCards;
